export default __webpack_public_path__ + "static/media/logo.624a87a7.png";